__turbopack_context__.v({
  "askArrow": "NmbZMG_askArrow",
  "askBar": "NmbZMG_askBar",
  "askGlyph": "NmbZMG_askGlyph",
  "askRow": "NmbZMG_askRow",
  "askText": "NmbZMG_askText",
  "body": "NmbZMG_body",
  "card": "NmbZMG_card",
  "cardFullBleed": "NmbZMG_cardFullBleed",
  "close": "NmbZMG_close",
  "container": "NmbZMG_container",
  "containerFullBleed": "NmbZMG_containerFullBleed",
  "field": "NmbZMG_field",
  "fieldClear": "NmbZMG_fieldClear",
  "fieldGlyph": "NmbZMG_fieldGlyph",
  "fieldInput": "NmbZMG_fieldInput",
  "footer": "NmbZMG_footer",
  "footerItem": "NmbZMG_footerItem",
  "header": "NmbZMG_header",
  "hint": "NmbZMG_hint",
  "idle": "NmbZMG_idle",
  "kbd": "NmbZMG_kbd",
  "list": "NmbZMG_list",
  "noResults": "NmbZMG_noResults",
  "overlay": "NmbZMG_overlay",
  "overlayFullBleed": "NmbZMG_overlayFullBleed",
  "promptButton": "NmbZMG_promptButton",
  "promptIcon": "NmbZMG_promptIcon",
  "promptText": "NmbZMG_promptText",
  "section": "NmbZMG_section",
  "sectionLabel": "NmbZMG_sectionLabel",
  "sections": "NmbZMG_sections",
  "sticky": "NmbZMG_sticky",
  "totalLabel": "NmbZMG_totalLabel",
});
